import { Col, Row } from "react-bootstrap";
import AlertIcon1 from "../../../../Img/whatsapp-icon.png";
import AlertIcon2 from "../../../../Img/egg-icon.png";
import AlertIcon3 from "../../../../Img/optimal-health.png";
import AppointmentIcon from "../../../../Img/appointment-icon.png";
import { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationList,
  readSingleNotification,
} from "redux/reducers/Notification/NotificationSlice";
import moment from "moment";

const AlertsList = () => {
  const dispatch = useDispatch();

  const { selectedLocation } = useSelector(({ role }) => role);

  const { notificationList, notificationPageLimit, notificationCurrentPage } =
    useSelector(({ notification }) => notification);

  const getNotificationListAPI = useCallback(() => {
    dispatch(
      getNotificationList({
        location_id: selectedLocation,
        start: notificationCurrentPage,
        limit: notificationPageLimit,
      })
    );
  }, [
    dispatch,
    selectedLocation,
    notificationPageLimit,
    notificationCurrentPage,
  ]);

  useEffect(() => {
    getNotificationListAPI();
  }, []);

  const handleSingleReadNotification = useCallback(
    (id) => {
      dispatch(
        readSingleNotification({
          location_id: selectedLocation,
          notification_id: id,
        })
      )
        .then(() => {
          getNotificationListAPI();
        })
        .catch((error) => {
          console.error("Error marking single notifications as read:", error);
        });
    },
    [dispatch, getNotificationListAPI, selectedLocation]
  );

  return (
    <div className="alert_tab">
      <div className="container">
        <Row className="justify-content-center">
          <Col xl={10} xs={12}>
            {notificationList?.list && (
              <div className="alert-card-list">
                {notificationList?.list?.map((notification) => {
                  const createdAtTime = moment(
                    notification?.created_at
                  ).fromNow();

                  return (
                    <div
                      className={`alert-card ${
                        !notification?.is_read ? "unread_card" : ""
                      }`}
                      onClick={() => {
                        !notification?.is_read &&
                          handleSingleReadNotification(notification?._id);
                      }}
                    >
                      <div className="card-content">
                        <div className="profile-img">
                          <div className="icon">
                            {notification?.user_name?.charAt(0)}
                          </div>
                        </div>

                        <div className="profile-details">
                          <div className="name">
                            {notification?.user_name}{" "}
                            <span className="time">{createdAtTime}</span>
                          </div>
                          <p>
                            {notification?.title} - {notification?.message}
                          </p>
                        </div>
                      </div>
                      {/* <div className="card-btn">
                      <button className="btn_primary">Send Message</button>
                    </div> */}
                    </div>
                  );
                })}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default memo(AlertsList);
